<template>
  <div>
    <div v-if="allowLogin">
      <div v-if="showForgotPassword">
        <h1
          v-bind:style="{ color: Company.CI_Headlinecolor }"
        >{{Company.RegisterMode == 1 ? LanguageStrings[DisplayLanguage]['forgotpassword_letter'] : LanguageStrings[DisplayLanguage]['forgotpassword_mail']}}</h1>
      </div>
      <div v-if="!showForgotPassword">
        <h1
          v-bind:style="{ color: Company.CI_Headlinecolor }"
        >{{LanguageStrings[DisplayLanguage]['headline_login']}}</h1>

        <form id="loginform" onsubmit="return false;" class="mt-4">
          <div class="form-group">
            <label
              for="form_user"
              v-bind:style="{ color: Company.CI_Textcolor }"
            >{{LanguageStrings[DisplayLanguage]['username']}}</label>
            <input
              type="text"
              class="form-control"
              name="form_user"
              placeholder="E-Mail-Adresse"
              v-model="Session.To"
              disabled="disabled"
            />
          </div>
          <div class="form-group">
            <label
              for="form_password"
              v-bind:style="{ color: Company.CI_Textcolor }"
            >{{LanguageStrings[DisplayLanguage]['password']}}</label>
            <input
              type="password"
              autocomplete="password"
              class="form-control"
              name="form_password"
              v-model="password"
              placeholder
              autofocus
              v-on:keyup.enter="login()"
            />
          </div>
          <div class="d-flex flex-row justify-content-between">
            <div>
              <input
                class="btn btn-primary"
                type="button"
                :value="LanguageStrings[DisplayLanguage]['passwort_vergessen']"
                @click="forgotPassword()"
              />
            </div>
            <div>
              <input
                class="btn btn-success"
                type="button"
                :value="LanguageStrings[DisplayLanguage]['anmelden']"
                @click="login()"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="showActivateEmail">
      <div v-if="showActivateEmailOk"><h1
          v-bind:style="{ color: Company.CI_Headlinecolor }"
        >{{LanguageStrings[DisplayLanguage]['login_resend_activateemail_ok']}}</h1></div>
      <div v-if="!showActivateEmailOk">
        <h1
          v-bind:style="{ color: Company.CI_Headlinecolor }"
        >{{LanguageStrings[DisplayLanguage]['login_activateemail']}}</h1>
        <input
          class="btn btn-primary float-right"
          type="button"
          :value="LanguageStrings[DisplayLanguage]['login_resend_activateemail']"
          @click="resendActivationEmail()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginHella",
  components: {
    //HelloWorld
  },
  data: function() {
    return {
      password: null,
      showForgotPassword: false,
      allowLogin: true,
      showActivateEmail: false,
      showActivateEmailOk: false
    };
  },
  mounted: function() {
    if (this.Session == null) {
      this.allowLogin = false;
    } else {
      if (this.Session.Unregistered) {
        this.allowLogin = false;
      } else {
        if (!this.Session.EmailActivated) {
          this.allowLogin = false;
          this.showActivateEmail = true;
        }
      }
    }
  },
  computed: {},
  methods: {
    login: function() {
      this.$parent.errortext = null;
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/login/" + this.Session.SessionId,
          this.form2JSON(document.getElementById("loginform")),
          {}
        )
        .then(function(response) {
          self.GS.Session = response.data;
          self.$router.push("/read");
        })
        .catch(function(response) {
          //console.log(response);
          self.password = null;
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          if (response.response.status == 403) {
            self.$parent.errortext = "loginblocked";
            return;
          }
          if (response.response.status == 401) {
            self.$parent.errortext = "loginfailed";
            return;
          }

          self.$parent.errortext = "internalservererror";
        });
    },
    forgotPassword: function() {
      this.$parent.errortext = null;
      var self = this;
      this.showForgotPassword = true;
      if(this.Session.Company.RegisterMode == 1)
      {
        return;
      }
      axios
        .post(
          this.GS.Endpoint + "/v2/forgotpassword/" + this.Session.SessionId,
          {},
          {}
        )
        .then(function(response) {})
        .catch(function(response) {
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          self.$parent.errortext = "internalservererror";
        });
    },
    resendActivationEmail: function() {
      this.$parent.errortext = null;
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/resendactivation/" + this.Session.SessionId,
          {},
          {}
        )
        .then(function(response) {
          self.showActivateEmailOk = true;
        })
        .catch(function(response) {
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          self.$parent.errortext = "internalservererror";
        });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
input {
  font-size: 13px;
}
</style>
